// Custom Product Colour web component for changing the colour of the product image

class CustomProductColour extends HTMLElement {
    constructor() {
        super();
        this.data = {
            primaryImageUrl: this.dataset?.primaryImage,
            secondaryImageUrl: this.dataset?.secondaryImage,
            id: this.dataset?.id,
            url: this.dataset?.url,
            colour: this.title,
            comparePrice: Number(this.dataset?.comparePrice),
            price: Number(this.dataset?.price),
            link: this.dataset?.link === 'true' ? true : false
        }

        if(this.data.link) {
            this.addEventListener('click', e => this.updateUrl(e, this.data.url));
        } else {
            this.addEventListener('click', e => this.updateProductColour(e, this.data.primaryImageUrl, this.data.secondaryImageUrl, this.data.colour, this.data.url, this.data.id, this.data.price, this.data.comparePrice));
        }
    }
    setActiveColour(colours) {
        colours.forEach(colour => colour.classList.remove('active'));

        this.classList.add('active');
    }
    updateUrl(e, url, selector = '.product'){
        e.preventDefault();
        let productColours = document.querySelectorAll(`${selector} .product-custom-colours__colour`);

        this.setActiveColour(productColours);

        if (url) {
            // Strip tracking parameters from URL
            const cleanUrl = url.split('?')[0];
            window.location.href = cleanUrl;
        }
    }
    updateProductColour(e, newPrimaryImageUrl, newSecondaryImageUrl, newColour, newUrl, newId, newPrice, newComparePrice) {
        let productCard = this.closest('product-item'),
            currentColour = productCard?.dataset?.currentColour,
            baseColour = productCard?.dataset?.baseColour,
            productCardLink = productCard?.querySelector('.product-item__aspect-ratio'),
            primaryImage = productCard?.querySelector('.product-item__primary-image'),
            secondaryImage = productCard?.querySelector('.product-item__secondary-image'),
            primaryImageUrl = primaryImage?.src.split('&')[0].replace('https:', ''),
            secondaryImageUrl = secondaryImage?.src.split('&')[0].replace('https:', ''),
            updatedPrimaryImageUrl = newPrimaryImageUrl?.split('&')[0],
            updatedSecondaryImageUrl = newSecondaryImageUrl?.split('&')[0],
            quickBuyPopover = productCard.querySelector('quick-buy-popover'),
            quickBuyDrawer = productCard.querySelector('quick-buy-drawer'),
            productCardColours = productCard.querySelectorAll('custom-product-colour'),
            productCardPrice = productCard.querySelector('.price-list .price'),
            productCardComparePrice = productCard.querySelector('.price-list .price.price--compare'),
            productCardLabels = productCard.querySelectorAll('.product-item__label-list');

        e.preventDefault();
        e.stopImmediatePropagation();

        this.setActiveColour(productCardColours);

        if (currentColour === newColour) return;

        if (!!newId) productCard.dataset.currentId = newId;

        if (!!newColour) {
            productCard.dataset.currentColour = newColour;
            productCard.dataset.showWishlist = baseColour !== newColour ? false : true;

            productCardLabels.forEach(label => label.classList.add('hide-labels'));
            productCard.querySelector(`[data-labels="${newColour}"]`)?.classList.remove('hide-labels');
        }

        if (newPrice > 0 && !!productCardPrice) {
            productCardPrice.innerHTML = window.formatMoney(newPrice);
        }

        if (newComparePrice > 0) {
            if (!!productCardComparePrice) {
                productCardComparePrice.innerHTML = window.formatMoney(newComparePrice);
            } else {
                let newPriceElement = document.createElement('span');
                newPriceElement.classList.add('price', 'price--compare');
                newPriceElement.innerHTML = window.formatMoney(newComparePrice);
                productCardPrice.after(newPriceElement);
                productCardPrice?.classList.add('price--highlight');
            }
        } else if (!!productCardComparePrice) {
            productCardComparePrice.remove();
            productCardPrice?.classList.remove('price--highlight');
        }

        if (!!newUrl) {
            // Strip tracking parameters from URL
            const cleanUrl = newUrl.split('?')[0];
            productCardLink.href = cleanUrl;
            if (!!quickBuyPopover) {
                let popoverUrl = `${cleanUrl}?view=quick-buy-popover`;
                quickBuyPopover.innerHTML = '';
                quickBuyPopover.setAttribute('href', popoverUrl);
            }
            if (!!quickBuyDrawer) {
                let drawerUrl = `${cleanUrl}?view=quick-buy-drawer`;
                quickBuyDrawer.innerHTML = '';
                quickBuyDrawer.setAttribute('href', drawerUrl);
            }
        }

        if (!!primaryImage && !!updatedPrimaryImageUrl && primaryImageUrl !== updatedPrimaryImageUrl) {
            let primarySplitSrcSet = primaryImage.srcset.split(',');
            primarySplitSrcSet = primarySplitSrcSet.map(srcSet => {
                let widthSplitSet = srcSet.split('&'),
                    newSet = `${updatedPrimaryImageUrl}&${widthSplitSet[1]}`;
                return srcSet.replace(srcSet, newSet);
            });
            primaryImage.src = updatedPrimaryImageUrl;
            primaryImage.srcset = primarySplitSrcSet.toString();
            primaryImage.alt = primaryImage.alt.replace(currentColour, newColour);
        }
        if (!!secondaryImage && !!updatedSecondaryImageUrl && secondaryImageUrl !== updatedSecondaryImageUrl) {
            let secondarySplitSrcSet = secondaryImage.srcset.split(',');
            secondarySplitSrcSet = secondarySplitSrcSet.map(srcSet => {
                let widthSplitSet = srcSet.split('&'),
                    newSet = `${updatedSecondaryImageUrl}&${widthSplitSet[1]}`;
                return srcSet.replace(srcSet, newSet);
            });
            secondaryImage.src = updatedSecondaryImageUrl;
            secondaryImage.srcset = secondarySplitSrcSet.toString();
            secondaryImage.alt = secondaryImage.alt.replace(currentColour, newColour);
        }
    }
}

customElements.define('custom-product-colour', CustomProductColour);
